import { ComponentProps } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { withStyles } from '../../../utils';

import styles from './CardTabs.module.scss';

const classes = withStyles(styles);

export type CardTabsVariant =
  // Tabs joined to the card with curved shoulders, each casting its own shadow.
  | 'default'
  // A flat sheet: plain tabs, and the card casts a single shadow upward along
  // its top edge across its full width (the contact drawer's tabs in Figma).
  | 'topShadow';

type RootProps = ComponentProps<typeof Tabs.Root> & {
  variant?: CardTabsVariant;
};

export function Root({ className, children, variant = 'default', ...props }: RootProps) {
  return (
    <Tabs.Root {...props} className={classes('cardTabsContainer', variant === 'topShadow' && 'topShadow', className)}>
      {children}
    </Tabs.Root>
  );
}

export function List({ className, children, ...props }: ComponentProps<typeof Tabs.List>) {
  return (
    <Tabs.List {...props} className={classes('tabList', className)}>
      {children}
    </Tabs.List>
  );
}

export function Trigger({ className, children, ...props }: ComponentProps<typeof Tabs.Trigger>) {
  return (
    <Tabs.Trigger
      {...props}
      className={classes('trigger', className)}
      style={{
        '--clipPath': `url(#${props.value})`,
      }}
    >
      {children}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="0"
        height="0"
        style={{
          opacity: 0,
          position: 'fixed',
          top: '-1000%',
          left: '-1000%',
        }}
      >
        <defs>
          <clipPath id={props.value} clipPathUnits="objectBoundingBox">
            <path d="M 0 1 C 1 1 1 0.9 1 .062 L 1 1 Z" />
          </clipPath>
        </defs>
      </svg>
    </Tabs.Trigger>
  );
}

export function Content({ className, children, ...props }: ComponentProps<typeof Tabs.Content>) {
  return (
    <Tabs.Content {...props} className={classes('content', className)}>
      {children}
    </Tabs.Content>
  );
}
